import { render, staticRenderFns } from "./openinghours.vue?vue&type=template&id=02eae074&"
import script from "./openinghours.vue?vue&type=script&lang=js&"
export * from "./openinghours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports